import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { Material } from '../../vendor/data/material';
import { CvMaterial } from './cv-material';

@JsonObject('model.cv.OrderItem')
export class OrderItem extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(Material, 'material')
    material?: Material;

    @JsonProperty(CvMaterial, 'cvMaterial')
    cvMaterial?: CvMaterial;

    @JsonProperty(Number, 'orderedQuantity')
    orderedQuantity?: number;

    @JsonProperty(Number, 'reservedQuantity')
    reservedQuantity?: number;

    @JsonProperty(Number, 'inStockCount')
    inStockCount?: number;

    @JsonProperty(String, 'vendorCode')
    vendorCode?: string;

    @JsonProperty(Number, 'price')
    price?: number;

    @JsonProperty(Number, 'totalPrice')
    totalPrice?: number;

    @JsonProperty(Number, 'receivedQuantity')
    receivedQuantity?: number;

}